'use strict';
import $ from 'jquery';

var Backbone = require('backbone');
var $global = require('../../js/globalElements');
var mediator = require('../../js/mediator');
var config = require('../../js/config');
var Analytics = require('../Analytics/Analytics');
var ShowHide = require('../../js/components/ShowHide');
var breakpoints = require('../../js/breakpoints');
const OVERLAY_CLASSES = `${config.classes.hasHeaderDropdown} ${config.classes.hasmegaMenuOpen}`;
let currentTargetName = null;

$('.megamenu-tab-link').focus(function() {
  $('.megamenu-dropdown').hide();
  $('.arrowdown').show();
  $('.arrowup').hide();
});

$('.svg-wrapper').keydown(function(e) {
  if (e.keyCode === 13) {
    $('.megamenu-dropdown').show();
  }
});

class MegamenuView extends Backbone.View {

  events() {
    return {
      'mouseenter .megamenu-tab': 'tabHoverCapture',
      'mouseleave .megamenu-tab': 'tabHoverCapture'
    };
  }

  initialize() { }

  showHideMegaMenu() {
    function disableMegaMenu() {
      if (currentTargetName === 'Manufacturers') {
        return true;
      }
      if (currentTargetName === 'Datasheets') {
        return true;
      }
      if (currentTargetName === 'Reference Designs') {
        return true;
      }
      if (currentTargetName === 'Researchandevents') {
        return true;
      }
      if (currentTargetName === 'Designcenter') {
        return true;
      }
      if (currentTargetName === 'Indiegogo') {
        return true;
      }
      if (currentTargetName === 'IoT') {
        return true;
      }
      return false;
    }

    new ShowHide({
      el: this.$el,
      type: '.megamenu-tab:not(.showhide-ignore)',
      method: 'hover',
      activeClass: config.classes.megamenuOpen,
      onShow: function() {
        if (breakpoints.isGreaterThan(config.breakpoint.desktop, true)) {
          if (disableMegaMenu()) {
            return;
          }
          $global.$body.addClass(OVERLAY_CLASSES);
          mediator.trigger(config.events.megaMenu.open);
        }
      },
      onHide: function() {
        if (!this.active && breakpoints.isGreaterThan(config.breakpoint.desktop, true)) {
          $global.$body.removeClass(OVERLAY_CLASSES);
        }
      }
    });
    new ShowHide({
      el: this.$el,
      type: '.megamenu-tab:not(.showhide-ignore)',
      method: 'focus',
      activeClass: config.classes.megamenuOpen,
      onShow: function() {
        if (breakpoints.isGreaterThan(config.breakpoint.desktop, true)) {
          if (disableMegaMenu()) {
            return;
          }
          $global.$body.addClass(OVERLAY_CLASSES);
          mediator.trigger(config.events.megaMenu.open);
        }
      },
      onHide: function() {
        if (!this.active && breakpoints.isGreaterThan(config.breakpoint.desktop, true)) {
          $global.$body.removeClass(OVERLAY_CLASSES);
        }
      }
    });
    new ShowHide({
      el: this.$el,
      type: '.megamenu-tab:not(.showhide-ignore)',
      method: 'keydown',
      activeClass: config.classes.megamenuOpen,
      onShow: function() {
        if (breakpoints.isGreaterThan(config.breakpoint.desktop, true)) {
          if (disableMegaMenu()) {
            return;
          }
          $global.$body.addClass(OVERLAY_CLASSES);
          mediator.trigger(config.events.megaMenu.open);
        }
      },
      onHide: function() {
        if (!this.active && breakpoints.isGreaterThan(config.breakpoint.desktop, true)) {
          $global.$body.removeClass(OVERLAY_CLASSES);
        }
      }
    });
  }

  tabHoverCapture(e) {
    if (e.type === 'mouseenter') {
      if (this.hoverCapturing) {
        if (this.hoverCapturing.target === e.currentTarget) {
          return;
        } else {
          clearTimeout(this.hoverCapturing.inTimeout);
        }
      }
      this.hoverCapturing = {
        target: e.currentTarget
      };
      const targetData = e.currentTarget.dataset;
      currentTargetName = targetData.gtmLabel;
      this.showHideMegaMenu();
      this.hoverCapturing.inTimeout = setTimeout(() => {
        Analytics.emitNewDataLayerEvent({
          event: targetData.gtmEvent,
          category: targetData.gtmCategory,
          action: targetData.gtmAction,
          label: targetData.gtmLabel
        });
      }, 250);
    } else {
      if (this.hoverCapturing && this.hoverCapturing.target === e.currentTarget) {
        clearTimeout(this.hoverCapturing.inTimeout);
      }
    }
  }
}

export function create($parent) {
  //Validate if the element is loaded
  var el = $parent[0].querySelector('.megamenu-wrapper .megamenu');
  new MegamenuView({ el });
}



// WEBPACK FOOTER //
// ./assets/components/MegaMenu/MegamenuView.js